import React, { ReactElement } from 'react';

import LoginPage from './containers/LoginPage/loginPage';

const UnauthenticatedApp = (): ReactElement => <LoginPage />;

export default UnauthenticatedApp;
